<aside>
  <app-sidenav-logo></app-sidenav-logo>
  <ul>
    <li>
      <app-mb-collapse content="Dashboard" preicon="fas fa-tachometer-alt" (click)="goto('/')"></app-mb-collapse>
    </li>
    @if (userEmail === 'fgarcia@m-shop.mobi') {
      <li>
        <app-mb-collapse content="Compañías" preicon="fas fa-landmark" (click)="goto('/companies')"></app-mb-collapse>
      </li>
    }
    <li>
      <app-mb-collapse content="Licencias" preicon="fas fa-file-code" (click)="goto('/licenses')"></app-mb-collapse>
    </li>
  </ul>
</aside>
